import React from 'react';
import { connect } from 'react-redux';
import AppWrapper from '../app_wrapper';
import ContactUsMobile from '../components_mobile/pages/ContactUs';
import ContactUsDesktop from '../components_desktop/pages/ContactUs';
import { apiGet } from '../modules/api';
import metadata from '../helpers/metadataHelper';

const ContactUsComponent = props => (
  <>
    <AppWrapper
      desktopComp={<ContactUsDesktop {...props} />}
      mobileComp={<ContactUsMobile {...props} />}
      metadata={metadata.contactUs}
    />
  </>
);

ContactUsComponent.getInitialProps = ({ store, req, res }) => store.dispatch(apiGet('api/home', req, res));

const mapStateToProps = () => ({});

const ContactUs = connect(mapStateToProps)(ContactUsComponent);
export default ContactUs;
